export interface CaenSectionInfo {
  code: string;
  name: string;
  icon: string;
}

export const CAEN_SECTIONS: CaenSectionInfo[] = [
  { code: 'A', name: 'Agricultura, silvicultura si pescuit', icon: '🌾' },
  { code: 'B', name: 'Industria extractiva', icon: '⛏️' },
  { code: 'C', name: 'Industria prelucratoare', icon: '🏭' },
  { code: 'D', name: 'Productia si furnizarea de energie', icon: '⚡' },
  { code: 'E', name: 'Distributia apei; salubritate', icon: '💧' },
  { code: 'F', name: 'Constructii', icon: '🏗️' },
  { code: 'G', name: 'Comert cu ridicata si cu amanuntul', icon: '🛒' },
  { code: 'H', name: 'Transport si depozitare', icon: '🚛' },
  { code: 'I', name: 'Hoteluri si restaurante', icon: '🏨' },
  { code: 'J', name: 'Editare, difuzare programe radio si TV', icon: '📺' },
  { code: 'K', name: 'Telecomunicatii si tehnologia informatiei', icon: '💻' },
  { code: 'L', name: 'Intermedieri financiare si asigurari', icon: '🏦' },
  { code: 'M', name: 'Tranzactii imobiliare', icon: '🏠' },
  { code: 'N', name: 'Activitati profesionale, stiintifice si tehnice', icon: '🔬' },
  { code: 'O', name: 'Activitati de servicii administrative si suport', icon: '📋' },
  { code: 'P', name: 'Administratie publica si aparare', icon: '🏛️' },
  { code: 'Q', name: 'Invatamant', icon: '📚' },
  { code: 'R', name: 'Sanatate si asistenta sociala', icon: '🏥' },
  { code: 'S', name: 'Activitati de spectacole, culturale si recreative', icon: '🎭' },
  { code: 'T', name: 'Alte activitati de servicii', icon: '🔧' },
  { code: 'U', name: 'Activitati ale gospodariilor private', icon: '🏡' },
];
